export default 'prod_ferrari'
